import { Draft } from 'immer';
import { Store, Common } from 'interfaces';
import updateError from './updateError';
import { travelReasonSuccess, travelReasonPending, travelReasonError } from './setTravelReasons';
import { TravelCategory, TravelReason } from 'interfaces/common';

const actions = (state: Draft<Store.State>) => ({
  updateError(error?: Common.Error) {
    updateError(state, error);
  },

  setTravelReasons(reasons: TravelReason[], categories: TravelCategory[]) {
    travelReasonSuccess({ reasons, categories }, state);
  },

  setTravelReasonsError(error: string) {
    travelReasonError(error, state);
  },

  setTravelReasonsLoading() {
    travelReasonPending(state);
  }
});

export default actions;
